import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";

const initialBillsState = {
    entities: [],
    totalCount: null,
    listLoading: false,
    actionsLoading: false,
    message: {
        error: null,
        success: null,
        completed: null,
    },
};

export const callTypes = {
    list: "list",
    action: "action",
};

export const BillsSlice = createSlice({
    name: "bills",
    initialState: initialBillsState,
    reducers: {
        catchError: (state, action) => {
            let error =
                action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
            if (error.constructor.name === "Object") {
                let temp = [];
                for (let [k, v] of Object.entries(error)) {
                    temp.push(`${k}->${v}`);
                }
                error = temp;
            }
            state.message.error = error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.message.success = null;
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // items fetched from api
        ItemsListFetched: (state, action) => {
            const { totalCount, entities } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },
        itemCreated: (state, action) => {
            const { message, entity } = action.payload;
            state.actionsLoading = false;
            state.error = null;
            state.entities.push(entity);
            state.totalCount = state.totalCount + 1;
            state.message.success = message;
        },
    },
});
